import { render, staticRenderFns } from "./popup-add.vue?vue&type=template&id=09d7d953&scoped=true"
import script from "./popup-add.vue?vue&type=script&lang=js"
export * from "./popup-add.vue?vue&type=script&lang=js"
import style0 from "./popup-add.vue?vue&type=style&index=0&id=09d7d953&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7d953",
  null
  
)

export default component.exports